import { render, staticRenderFns } from "./DownloadSelectionSection.vue?vue&type=template&id=6de15190&scoped=true"
import script from "./DownloadSelectionSection.vue?vue&type=script&lang=js"
export * from "./DownloadSelectionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de15190",
  null
  
)

export default component.exports